import styled from "styled-components"
import { ReactComponent as KustomLogo } from "images/providers/kustom-logo.svg"

type StyledProps = {
 $logoMargin: string
}

export const Container = styled.div`
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  padding: 2rem;
  position: relative;
  width: 100%;
  display: grid;
  gap: 2rem;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    padding: 2rem 4rem 2rem;
  }
`

export const Label = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 1rem;
    height: 2rem;
  }

`

export const Title = styled.h2<StyledProps>`
  display: flex;
  align-items: center;
  margin-top: 1rem;

  svg {
    height: 2.4rem;
    margin: ${(p) => p.$logoMargin}
  }
`

export const ChildrenWrapper = styled.div`
display: flex;
  flex-direction: column;
`

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    grid-template-columns: repeat(2, 1fr);
  }

`

export const CopyWrapper = styled.div`
  display: flex;

  svg {
    margin-top: 2.1rem;
  }
`

export const StyledKustomLogo = styled(KustomLogo)`
width: fit-content;
height: 1.6rem !important;

`
